globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Emailing = appCustomerSpace.Modals.Emailing || {};

appCustomerSpace.Modals.Emailing.EditNewsletter = (function(superClass) {

  utils.extend(EditNewsletter, superClass);

  function EditNewsletter() {
    return EditNewsletter.__super__.constructor.apply(this, arguments);
  }

  $.extend(EditNewsletter.prototype, {
    init: function() {
      return EditNewsletter.__super__.init.apply(this, arguments);
    }
  });

  return EditNewsletter;

})(appCustomerSpace.Modal);
